<form
      name="positionForm"
      class="p-4"
      [formGroup]="positionForm"
      novalidate>
  <div class="row g-2 mb-2">
    <div class="col-12">
      <label>Position</label>
      <input type="text"
             class="form-control"
             [ngClass]="{
           'form-required-border':
             positionForm.get('positionName').invalid &&
             positionForm.get('positionName').touched
         }"
             formControlName="positionName"
             placeholder="Position Name" />
    </div>
  </div>

</form>
